const scaleDecimal = (num) => {
  const numStr = String(parseFloat(num));
  if (numStr.includes('.')) {
    return numStr.split('.')[1].length;
  }
  return 0;
};

export default scaleDecimal;
